module.exports = __webpack_public_path__ + "img/FILTROS.4bec635f.svg";